<template>
	<el-container id="edit-content" class="full-window-height-container">
		<el-header class="dms-edit-layout-header layout-component-padding" height="45px">
			<el-button-group v-if="canSave || saveAsButton" class="left-margin btn-align-right">
				<dms-tooltip v-if="canSave" :content="LocalizePopisPoli('SAVE_BUTTON')" popper-class="btn-tooltip">
					<dms-save data-cy="editLayoutSubmitButton" v-bind="{ isModified, isArchive }" @click="saveClick" />
				</dms-tooltip>
				<dms-button v-if="saveAsButton" class="btn-align-right" size="small" type="primary"
					@click="$emit('save-as-click')">
					<i class="icon-floppy-disk save-as-icon" />
				</dms-button>
			</el-button-group>
			<dms-tooltip v-if="allowClose" :content="LocalizePopisPoli('CLOSE_BUTTON')" popper-class="btn-tooltip">
				<dms-close class="left-margin btn-align-right" data-cy="closeButton" @closeClick="closeClick" />
			</dms-tooltip>
			<dms-button v-if="showReportRequestButton" :disabled="false" label-key="ReportRequestStatus"
				icon="el-icon-d-arrow-right" class="left-margin btn-align-right" @click="navigateToReportRequests" />
			<dms-button v-if="addButton" ref="addButton" data-cy="editLayoutAddButton" size="small" icon="el-icon-plus"
				@click="$emit('add-click')" />
			<dms-tooltip v-if="canDelete" :content="LocalizePopisPoli('DELETE_BUTTON')" popper-class="btn-tooltip">
				<dms-delete class="btn-align-right" @click="deleteClick" />
			</dms-tooltip>
			<template v-if="$slots.actions">
				<i v-if="showArrow" class="icon-arrow-left left-arrow-layout" @click="scrollNavbarLeft()" />
				<span ref="title" class="button-box">
					<slot name="actions" />
				</span>
				<i v-if="showArrow" class="icon-arrow-right right-arrow-layout" @click="scrollNavbarRight()" />
			</template>
		</el-header>
		<el-main class="layout-container-edit">
			<dms-form ref="mainForm" :model="model" :validate-on-rule-change="false" :rules="validationRules">
				<el-col class="top-card">
					<slot name="topCard" />
				</el-col>
				<slot />
				<el-col class="tabs-wrapper">
					<slot name="tabsContent" />
					<!-- TODO: TP1 vyresit poc ve default slotu se pridava el-row s margin-left 5px -->
				</el-col>
			</dms-form>
		</el-main>
	</el-container>
</template>
<script>
import Vue from 'vue';
import { PageMode } from '@/main/utils/pageMode';

import { OperationFlags } from '#components/dms/common/operationFlagsConstants';
import { navigateToReportRequests } from '@/main/utils/commonFunctions';
import Close from '#components/dms/button/Close.vue';
import Save from '#components/dms/button/Save.vue';
import Delete from '#components/dms/button/Delete.vue';

export default Vue.extend({
	name: 'DmsEditLayout',
	components: {
		'dms-close': Close,
		'dms-save': Save,
		'dms-delete': Delete,
	},
	props: {
		validationRules: { type: Object, default: () => { } },
		operations: { type: Number, default: 0 },
		mode: { type: String, default: PageMode.VIEW },
		saveClick: { type: Function, default: () => { } },
		deleteClick: { type: Function, default: () => { } },
		closeClick: { type: Function, default: () => { } },
		allowDelete: { type: Boolean, default: true },
		allowSave: { type: Boolean, default: true },
		allowClose: { type: Boolean, default: true },
		model: { type: Object, default: () => { } },
		addButton: Boolean,
		saveAsButton: Boolean,
		isModified: { type: Boolean, required: true },
		isArchive: Boolean,
		showReportRequestButton: { type: Boolean, default: false }, // Only this prop needed
	},
	data() {
		return {
			showArrow: false,
		};
	},
	computed: {
		canSave() {
			return (this.mode !== PageMode.VIEW && this.canEdit) || (this.mode === PageMode.CREATE && this.canCreate);
		},
		canEdit() {
			// eslint-disable-next-line no-bitwise
			return !this.allowSave ? false : this.operations & OperationFlags.EDIT;
		},
		canCreate() {
			// eslint-disable-next-line no-bitwise
			return !this.allowSave ? false : this.operations & OperationFlags.CREATE;
		},
		canDelete() {
			// eslint-disable-next-line no-bitwise
			return (!this.allowDelete ? false : this.operations & OperationFlags.DELETE) && this.mode !== PageMode.VIEW;
		},
		mainForm() {
			return this.$refs.mainForm;
		},
	},
	mounted() {
		this.getSpanWidth();
	},
	created() {
		window.addEventListener('resize', this.getWidth);
	},
	destroyed() {
		window.removeEventListener('resize', this.getWidth);
	},
	methods: {
		getSpanWidth() {
			if (this.$refs) {
				this.$nextTick(() => {
					this.showArrow = this.$refs && this.$refs !== undefined && this.$refs.title ? this.$refs.title.scrollWidth > this.$refs.title.clientWidth : false;
				});
			}
		},
		scrollNavbarRight() {
			const content = document.querySelector('.button-box');
			if (content !== null) {
				content.scrollLeft += 50;
			}
		},
		scrollNavbarLeft() {
			const content = document.querySelector('.button-box');
			if (content !== null) {
				content.scrollLeft -= 50;
			}
		},
		getWidth() {
			this.showArrow = this.$refs && this.$refs !== undefined && this.$refs.title ? this.$refs.title.scrollWidth > this.$refs.title.clientWidth : false;
		},
		navigateToReportRequests() {
		navigateToReportRequests();
		},
	},
});
</script>
<style scoped lang="scss">
.top-card:not(:first-of-type) {
	padding-top: 11px;
	overflow: visible;
}

.el-main>.el-form {
	height: calc(100vh - 110px);
	flex-direction: column;
	display: flex;
}

.tabs-wrapper {
	display: flex;
	overflow: auto;
}

.confirm-buttons,
.confirm-buttons+.el-button {
	margin-left: 10px;
}

.left-margin {
	margin-left: 0.625rem;
}

.save-as-icon {
	font-size: 99%;
}

.button-box {
	max-width: 60%;
	overflow: auto;
	display: inline-flex;
	padding-top: 9px;
}
@media screen and (max-width: 500px) {
	.button-box {
		max-width: 30%
	}
}
@media screen and (max-width: 398px) {
	.button-box {
		max-width: 22%
	}
}
.dms-edit-layout-header {
	border-bottom: 1px solid #ced4da;
}

</style>
